// src/billing/checkoutModal.tsx
import { LargePanelDialog, showModal } from "@lb-lib/ui";
import { getGlobalShellConfig } from "@loopbound-ares/state";
import { useEffect } from "react";
import { jsx } from "react/jsx-runtime";
var openCheckoutModal = async (transactionId) => {
  let checkoutUrl = new URL((await getGlobalShellConfig()).services.checkoutFrontendUrl);
  checkoutUrl.searchParams.set("transactionId", transactionId);
  showModal(({
    dialogProps,
    close
  }) => {
    useEffect(() => {
      let handleMessage = (e) => {
        if (e.data.type != "checkout-completed")
          return;
        close();
      };
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
    }, []);
    return /* @__PURE__ */ jsx(LargePanelDialog.Wrapper, { ...dialogProps, style: {
      height: "90vh",
      maxHeight: "90vh",
      minHeight: "90vh",
      display: "flex",
      flexDirection: "column"
    }, children: /* @__PURE__ */ jsx("iframe", { src: checkoutUrl.toString(), style: {
      width: "100%",
      height: "100%",
      border: "none",
      flex: 1
    } }) });
  }, {
    onClose: () => setTimeout(() => window.location.reload(), 100)
  });
};

export {
  openCheckoutModal
};
//# sourceMappingURL=chunk-IKCASY5M.js.map